module.exports = __webpack_public_path__ + "img/sign-8.70705ac8.jpg";